import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { useNavigate } from 'react-router-dom';
import { Heart, Repeat } from 'lucide-react';

const SevaOfferingsSection = () => {
  const navigate = useNavigate();

  const sevaOfferings = [
    {
      id: 'prabhupada',
      title: 'Srila Prabhupada Seva',
      image: 'https://i.postimg.cc/7LZwfynW/prabhupada-2.jpg',
      description: 'Empower the foundational preaching activities established by Srila Prabhupada, including book distribution and Hari Naam Sankirtan.',
      amount: 51,
      color: 'saffron'
    },
    {
      id: 'tulasi',
      title: 'Srimati Tulasi Maharani Seva',
      image: 'https://i.postimg.cc/4xJTSTqx/tulasimaharani.jpg',
      description: 'Support the daily worship of Tulasi Devi, whose blessings are essential for the success of all our preaching efforts, from book distribution to youth outreach.',
      amount: 101,
      color: 'gold'
    },
    {
      id: 'sudarshan',
      title: 'Shri Sudarshan Seva',
      image: 'https://i.postimg.cc/5tyWfSxc/sudharshan.jpg',
      description: 'Help protect our preaching mission by supporting the logistics and travel for our Hari Naam parties and book distribution teams.',
      amount: 151,
      color: 'blue'
    },
    {
      id: 'nrsimha',
      title: 'Shri Nrsimha Dev Seva',
      image: 'https://i.postimg.cc/BnsqfFLs/nrsimhadev.jpg',
      description: 'Sponsor the needs of the devotees on the front lines, enabling them to fearlessly organize spiritual youth camps and distribute books.',
      amount: 251,
      color: 'maroon'
    },
    {
      id: 'gauranitai',
      title: 'Gaura Nitai Seva',
      image: 'https://i.postimg.cc/cCwNV1dr/gauranitai.jpg',
      description: 'Directly sponsor a large-scale Hari Naam (congregational chanting) event, spreading the special mercy of Sri Gaura Nitai throughout the city.',
      amount: 501,
      color: 'saffron'
    },
    {
      id: 'jbs',
      title: 'JBS Seva (Jagannath, Baladeva, Subhadra)',
      image: 'https://i.postimg.cc/q7FVq6RN/jbs.jpg',
      description: 'Sponsor a grand feast for the Lord of the Universe and the subsequent distribution of hundreds of plates of Mahaprasadam, a cornerstone of our preaching.',
      amount: 1001,
      color: 'gold'
    },
    {
      id: 'radhakrishna',
      title: 'Sri Sri RadhaKrishna Seva',
      image: 'https://i.postimg.cc/V6byCsrD/radhakrishna.jpg',
      description: 'Fund an entire spiritual youth camp, inspiring the next generation with Krishna consciousness through interactive workshops, kirtan, and prasadam.',
      amount: 1501,
      color: 'blue'
    },
    {
      id: 'radhagopi',
      title: 'Sri Sri RadhaGopi Vallabha Seva',
      image: 'https://i.postimg.cc/qMHr2KGn/radhagopivallabha.jpg',
      description: 'Become a patron of our entire monthly outreach program. This seva funds large-scale book distribution, multiple Hari Naams, extensive prasadam distribution, and materials for our youth camps.',
      amount: 2001,
      color: 'maroon'
    }
  ];

  const handleDonate = (seva) => {
    navigate(`/donate/${seva.id}`, { state: { seva } });
  };

  const handleSubscribe = () => {
    navigate('/donate/subscription', { state: { isSubscription: true } });
  };

  return (
    <section className="seva-offerings-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-heading">An Offering of Love & Devotion</h2>
          <p className="section-subtitle">Choose a Seva to directly support our preaching mission.</p>
        </div>

        <div className="seva-grid">
          {sevaOfferings.map((seva) => (
            <Card key={seva.id} className={`seva-card seva-${seva.color}`}>
              <CardHeader className="seva-header">
                <div className="seva-image-container">
                  <img
                    src={seva.image}
                    alt={seva.title}
                    className="seva-image"
                  />
                </div>
                <CardTitle className="seva-title">{seva.title}</CardTitle>
              </CardHeader>
              <CardContent className="seva-content">
                <p className="seva-description">{seva.description}</p>
                <div className="seva-footer">
                  <Badge variant="secondary" className="seva-amount">
                    ${seva.amount}
                  </Badge>
                  <Button
                    onClick={() => handleDonate(seva)}
                    className="donate-btn"
                  >
                    <Heart className="w-4 h-4 mr-2" />
                    Donate Now
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Recurring Donation Call-out */}
        <div className="subscription-callout">
          <Card className="subscription-card">
            <CardContent className="subscription-content">
              <div className="subscription-icon">
                <Repeat className="w-8 h-8" />
              </div>
              <div className="subscription-text">
                <h3 className="subscription-title">Become a Monthly Preaching Partner</h3>
                <p className="subscription-description">
                  Support the temple's outreach with a recurring monthly donation of $51 or more. As a token of our gratitude, please accept the divine blessings of Mangal Bhog, the first delicious sweet offered to the Lordships each day, whenever you visit.
                </p>
              </div>
              <Button
                onClick={handleSubscribe}
                className="subscribe-btn"
                size="lg"
              >
                <Repeat className="w-4 h-4 mr-2" />
                Subscribe Now
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default SevaOfferingsSection;